module.exports = "https://hallo-assembleias.api.hallo.app";
